export enum RestoreOption {
  Individual = 'RestoreIndividualMarker',
  AllIndividual = 'RestoreAllIndividualMarkers',
  Group = 'RestoreGroupMarkers',
  All = 'RestoreAllMarkers',
}
